import { render, staticRenderFns } from "./radar.md?vue&type=template&id=e824056e&"
import script from "./radar.md?vue&type=script&lang=js&"
export * from "./radar.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e824056e')) {
      api.createRecord('e824056e', component.options)
    } else {
      api.reload('e824056e', component.options)
    }
    module.hot.accept("./radar.md?vue&type=template&id=e824056e&", function () {
      api.rerender('e824056e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/demo/radar/radar.md"
export default component.exports